// extracted by mini-css-extract-plugin
export default {"inner":"Memo_inner__d0wf+","label":"Memo_label__cA9Xv","arrow":"Memo_arrow__SnMGU","dot":"Memo_dot__tq8ls"};